import pluralize from 'helpers/pluralize';
import formatNumber from 'helpers/formatNumber';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';

/**
 * This component shows meta data of an artist.
 */
function ArtistMetadata({
  trackCount,
  releaseCount,
  isTrackCountDisplayed = true,
}) {
  return (
    <Meta>
      {shouldRenderValue(trackCount) && isTrackCountDisplayed && (
        <span>{`${formatNumber(trackCount)} ${pluralize(
          'track',
          trackCount
        )}`}</span>
      )}
      {shouldRenderValue(releaseCount) && (
        <span>{`${formatNumber(releaseCount)} ${pluralize(
          'release',
          releaseCount
        )}`}</span>
      )}
    </Meta>
  );
}

ArtistMetadata.propTypes = {
  ...metadataProps,
};

export default ArtistMetadata;
